import { module } from 'modujs';
import { clamp } from '../utils/maths';

export default class Panels extends module {

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$images = Array.from(this.$('image'))
        this.IMAGES_COUNT = this.$images.length

        this.currentImageIndex = 0
    }

    init() {
    }

    onScrollProgress(p) {
        const currentImageIndex = Math.round(p * this.IMAGES_COUNT)

        if(currentImageIndex === this.IMAGES_COUNT) {
            return
        }

        if(currentImageIndex !== this.currentImageIndex) {
            const p = this.currentImageIndex > currentImageIndex ? 0 : 1
            this.$images[this.currentImageIndex].style.setProperty('--panels-image-progress', p)
        }

        const imageProgress = this.easeInOutQuad(clamp(0, 1, 1.5 * (p * this.IMAGES_COUNT - currentImageIndex + 0.5)))
        this.$images[currentImageIndex].style.setProperty('--panels-image-progress', imageProgress)

        this.currentImageIndex = currentImageIndex
    }

    easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }

    destroy() {
    }
}
